module.exports = __webpack_public_path__ + "static/img/iconshengyin_24_hei.f568f325.png";